import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { Table, Tag } from "antd";
import { showConfirmDlgWidget } from "components/ConfirmDlgWidget/showConfirmDlgWidget";
import { STATUS_COLORS, STATUS_LABELS } from "../buyerUtils";

function TableWidget(props) {
  const [dataSource, setDataSource] = useState([]);
  const { dataList, onViewAction, onSuspendAction, onReactivateAction } = props;

  useEffect(() => {
    if (dataList !== undefined) {
      setDataSource([...dataList.map((info) => ({ ...info, key: info.id }))]);
    }
  }, [dataList]);
  if (dataList === undefined) return <div />;

  const columns = [
    {
      title: "Company",
      dataIndex: "company_name",
      render: (text, record) => (
        <div>
          <div style={{ fontWeight: 600 }}>{text}</div>
          <div style={{ color: "var(--darkGreyColor)", fontSize: 12 }}>{record.contact_person}</div>
        </div>
      ),
    },
    { title: "Email", dataIndex: "email" },
    {
      title: "Applied",
      dataIndex: "add_timestamp",
      align: "center",
      sorter: { compare: (a, b) => (a.add_timestamp || "").localeCompare(b.add_timestamp || "") },
    },
    { title: "Orders", dataIndex: "order_count", align: "center" },
    {
      title: "Status",
      dataIndex: "status",
      align: "center",
      render: (text) => <Tag color={STATUS_COLORS[text] || "default"}>{STATUS_LABELS[text] || text}</Tag>,
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (text, record) => (
        <div>
          <a style={{ color: "var(--blueColor)", marginLeft: 12 }} onClick={() => onViewAction(record)}>
            View
          </a>
          {record.status === "approved" && (
            <a
              style={{ color: "var(--redColor)", marginLeft: 16 }}
              onClick={async () => {
                const res = await showConfirmDlgWidget({
                  title: "Suspend account",
                  content: `Suspend ${record.company_name}'s wholesale account? They will be logged out and unable to sign in.`,
                });
                if (res == false) return;
                onSuspendAction(record);
              }}
            >
              Suspend
            </a>
          )}
          {record.status === "suspended" && (
            <a style={{ color: "var(--blueColor)", marginLeft: 16 }} onClick={() => onReactivateAction(record)}>
              Reactivate
            </a>
          )}
        </div>
      ),
    },
  ];

  return (
    <div className="list-table">
      <Table pagination={false} columns={columns} dataSource={dataSource} />
    </div>
  );
}

export default withRouter(TableWidget);
